/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：656
 */

module.exports = JSON.parse("{\"a\":\"1.22.0-0\"}")
